module.exports = __webpack_public_path__ + "img/workshift-plan2.2aac8890.jpg";